module.exports = __webpack_public_path__ + "static/media/InsureComp-1.43fbf433.jpg";